import { BodyLarge400 } from '@nebula/global-styles';
import styled from 'styled-components';

export const ModalLabel = styled(BodyLarge400)`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.color.ui.grey[100]};

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    font-size: 16px;
    line-height: 24px;
  }
`;
